import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=3b28e689&scoped=true&lang=html"
import script from "./AnswerForm.vue?vue&type=script&lang=js"
export * from "./AnswerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28e689",
  null
  
)

export default component.exports